/**
 * Which screen a fresh load should open on.
 *
 * Three things can decide that, and they are deliberately ranked: a
 * confirmation link is the reason somebody opened their mail client and has
 * to be spent now; an invite code means somebody is waiting; and the `view`
 * parameter is the manifest's app shortcuts — the long-press menu on the home
 * screen icon — which is a preference rather than an errand.
 */
export type StartView = 'home' | 'create' | 'join' | 'account' | 'stats';

export function readStartView(search: string): StartView {
  const params = new URLSearchParams(search);
  if (params.get('confirm')) return 'account';
  if (params.get('code')) return 'join';

  const view = params.get('view');
  // `stats` is not a shortcut in the manifest: it is the operator's own
  // bookmark to the usage numbers, and it is here rather than at a path of
  // its own because a path is a page crawlers find and people link to. It
  // needs no guard — the screen behind it is one request to a
  // moderator-only endpoint, which answers 403 for anybody else.
  if (view === 'create' || view === 'join' || view === 'stats') return view;
  return 'home';
}
